module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"content_hubs":{"navigation":{"header":"Mehr Fondswissen"}}}}}}')
  delete Component.options._Ctor
}
